import React, { useEffect } from 'react';
import eventBus, { EVENT_NAMES } from '../../utils/event_bus';
import MapView from '../components/map/map_view';
import DriverListView from './driver_list_view';
import { Box, Paper, Typography } from '@mui/material';
import { LocationDriver } from '../../models/response/LocationDriver';
import { useDataProvider } from 'react-admin';

/**
 * 司机地图页面
 * 显示地图和悬浮在上面的司机列表
 */
const MapDrivers: React.FC = () => {
  return (
    <Box sx={{ position: 'relative', height: 'calc(100vh - 40px)', width: '100%' }}>
      {/* 全屏地图 */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
        <MapView 
          center={[39.9042, 116.4074]} // 默认北京中心点
          zoom={10}
          height="100%"
          width="100%"
        />
      </Box>
      
      {/* 悬浮在右侧的司机列表 */}
      <Paper 
        elevation={6}
        sx={{ 
          position: 'absolute',
          top: '20px',
          right: '20px',
          height: 'calc(100vh - 80px)',
          width: '35%',
          maxWidth: '100%',
          borderRadius: '8px',
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // 半透明黑色背景
          color: 'white', // 文字颜色设为白色
          overflow: 'auto', // 内容过多时可滚动
          zIndex: 1000 // 确保在地图上层
        }}
      >
        <DriverListSidebar />
      </Paper>
    </Box>
  );
};

// 修改后的司机列表侧边栏组件，适配半透明黑色背景
const DriverListSidebar: React.FC = () => {
  return (
    <Box sx={{ padding: '2px' }}>
      <Typography 
        sx={{ 
          color: 'white', 
          textAlign: 'center', 
          marginBottom: '10px',
          padding: '5px 0',
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
          fontWeight: 'bold'
        }}
      >
        司机列表
      </Typography>
      <DriverListView />
    </Box>
  );
};

export default MapDrivers;